import script from "./BaseFigureForIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFigureForIcon.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFigureForIcon.vue?vue&type=style&index=0&id=2339f612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2339f612"]])

export default __exports__